import { Box, Typography } from "@mui/material";
import { useAppSelector } from "store/appHooks";

const options = [
  {
    label: "Loader Bucket",
    icon: "/assets/img/icons/tractor_b.svg",
    key: "has_loader_bucker",
  },
  {
    label: "3 Points Lift",
    icon: "/assets/img/icons/3pl_lift.svg",
    key: "has_3point_lift",
  },
  {
    label: "Power Streering",
    icon: "/assets/img/icons/pwr_str.svg",
    key: "has_power_steering",
  },
  {
    label: "Cabin",
    icon: "/assets/img/icons/cabin.svg",
    key: "has_cabin",
  },
  {
    label: "Heater",
    icon: "/assets/img/icons/heater.svg",
    key: "has_heater",
  },
  {
    label: "AC",
    icon: "/assets/img/icons/ac.svg",
    key: "has_ac",
  },
  {
    label: "PTO",
    icon: "/assets/img/icons/pto.svg",
    key: "has_pto",
  },
  {
    label: "4WD",
    icon: "/assets/img/icons/4wd.svg",
    key: "has_4wd",
  },
];

const ListingFeatures = () => {
  const { listingDetails }: any = useAppSelector(
    (state) => state.searchListingReducer
  );
  const listingFeatures = listingDetails?.listing_features?.[0] ?? {};

  if (listingDetails.listing_type === 2) return <></>;
  if (
    Object.values(listingFeatures)
      .filter((r) => typeof r === "boolean")
      .filter((r) => r === true).length === 0
  )
    return <></>;

  return (
    <Box
      sx={{
        px: { md: "2%", lg: "2%", xl: "2%", sm: "4%", xs: "4%" },
        py: "0px",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "18px",
          lineHeight: "31px",
          my: "15px",
        }}
      >
        Features
      </Typography>
      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "none",
            xs: "none",
          },
          flexWrap: "no-wrap",
          gap: "15px",
        }}
      >
        {options.map(
          (opt) =>
            listingFeatures?.[opt.key] && (
              <Box
                sx={{
                  //   boxShadow: "0px 3px 6px 0px #25334B1A",

                  boxShadow:
                    "0px 10px 20px 0px #25334B1A, 0px 3px 6px 0px #25334B1A",

                  height: "88px",
                  width: "170px",

                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "10px",
                  borderRadius: "10px",
                }}
              >
                <img src={opt.icon} alt="" />
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "15px",
                    lineHeight: "18px",
                    textAlign: "center",
                  }}
                >
                  {opt.label}
                </Typography>
              </Box>
            )
        )}
      </Box>

      <Box
        sx={{
          display: {
            md: "none",
            lg: "none",
            xl: "none",
            sm: "flex",
            xs: "flex",
          },
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        {options.map(
          (opt) =>
            listingFeatures?.[opt.key] && (
              <Box
                sx={{
                  //   boxShadow: "0px 3px 6px 0px #25334B1A",

                  //   boxShadow:
                  //     "0px 10px 20px 0px #25334B1A, 0px 3px 6px 0px #25334B1A",

                  //   height: "88px",
                  //   width: "160px",

                  width: "150px",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "10px",
                }}
              >
                <img src={opt.icon} alt="" />
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "15px",
                    lineHeight: "18px",
                    textAlign: "center",
                  }}
                >
                  {opt.label}
                </Typography>
              </Box>
            )
        )}
      </Box>
    </Box>
  );
};

export default ListingFeatures;
